import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeart = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M29.243 11.757C26.9 9.41401 23.101 9.41401 20.758 11.757C20.469 12.046 20.218 12.357 20.001 12.684C19.784 12.357 19.532 12.045 19.244 11.757C16.901 9.41401 13.102 9.41401 10.759 11.757C8.41602 14.1 8.41602 17.899 10.759 20.242L20 29.485L29.243 20.242C31.586 17.899 31.586 14.1 29.243 11.757Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})
});
const ForwardRef = forwardRef(SvgHeart);
export default ForwardRef;
